import { ProgressBar } from "react-bootstrap";
import React from "react";
import smartPercentCalculator from "helpers/smart-percent-calculator";

const getProgressBar = (voltage, minMaxConstants, showPercent = true) => {
  let className = "";
  const { min, max } = minMaxConstants;
  const third = (max - min) / 3;
  if (voltage) {
    if (Number(voltage) > 2 * third && Number(voltage) <= max) {
      className = "success";
    } else if (Number(voltage) > third && Number(voltage) <= 2 * third) {
      className = "warning";
    } else if (Number(voltage) <= third) {
      className = "danger";
    }
    const percent = smartPercentCalculator(min, max, Number(voltage));

    return (
      <div className="position-relative w-100" style={{
        height: 20
      }}>
        <div
          className="w-100 h-100  position-absolute text-center"
          style={{
            color: "#fff",
            textShadow: "1px 1px 2px #000",
            lineHeight: 1
          }}
        >
          {Number(voltage)} {showPercent ? `(${Math.round(percent)}%)` : ''}
        </div>
        <ProgressBar
          animated
          variant={className}
          now={percent}
          className="border"
        />
      </div>
    );
  }
  return false;
};

export default getProgressBar;



// WEBPACK FOOTER //
// ./src/views/pages/chargers/helpers/get-progress-bar.js